import { useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router";
import { CircularProgress } from "@mui/material";
// cmp
import SupportUserInfo from "../cmp/support-user/SupportUserInfo";
// hooks
import useStorage, { StorageKeys } from "../hooks/useStorage";
// contexts
import { useUserData } from "../context/UserDataContext";
// types
import type { UserId } from "../types/user";

type RouteParams = {
	userId?: UserId;
};

const SupportUsersPage = () => {
	const params = useParams<RouteParams>();
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const { ready } = useUserData();
	const [supportUserId] = useStorage(StorageKeys.supportUserId);
	const selectedSupportUserId = params.userId ?? supportUserId;

	useEffect(() => {
		if (selectedSupportUserId && pathname === "/support/users") {
			void navigate(`/support/users/${selectedSupportUserId}`);
		}
	}, [pathname, selectedSupportUserId, navigate]);

	if (!ready) {
		return <CircularProgress />;
	}
	if (selectedSupportUserId === null) {
		return null;
	}

	return <SupportUserInfo userId={selectedSupportUserId} onUserRemoved={() => (navigate("/support/users"))} />;
};

export default SupportUsersPage;
